import { createUseStyles } from 'react-jss'
import { backgroundColor, titleFont, color, textSize } from 'styles/helpers'


export default createUseStyles(theme => ({
  separator: {
    display: 'block',
    position: 'relative',
    marginBottom: 24,
    ...titleFont(),
    ...textSize(16, 19),
    letterSpacing: .15,
    textAlign: 'center',
    textTransform: 'uppercase',
    ...color('titleColor', theme.theme),

    '&:before, &:after': {
      content: "''",
      display: 'block',
      position: 'absolute',
      zIndex: 1,
      top: 9,
      height: 1,
      width: '40%',
      ...backgroundColor('textDefault', theme.theme),
      opacity: .25,
    },

    '&:before': {
      left: 0,
    },

    '&:after': {
      right: 0,
    }
  }
}))
